import React from 'react'
import { MenuItem } from './MenuItem'
import type { MenuListElement } from '../Header/menuList'

export const buildMenu = (root: MenuListElement[], lvl = 1) =>
  root.map((elt, i) => {
    const key = `${lvl}-${i}`
    return <MenuItem key={key} element={elt} level={lvl} />
  })
